import Ajax from '@/lib/ajax'

export default {
  getAll() {
    return Ajax.get('/api/productManagement/productSalesAttribute/all')
  },
  deleteById(id: string | number) {
    return Ajax.delete(`/api/productManagement/productSalesAttribute?id=${id}`)
  },
  edit(id: string | number, editData: any) {
    let ajaxType = id ? 'put' : 'post'
    let ajaxUrl = id
      ? `/api/productManagement/productSalesAttribute/${id}`
      : '/api/productManagement/productSalesAttribute'
    return Ajax[ajaxType](ajaxUrl, editData)
  },
  getDataById(id: string | number) {
    return Ajax.get(`/api/productManagement/productSalesAttribute/${id}`)
  },
  getList(pageSize: number, currentPage: number) {
    return Ajax.get('/api/productManagement/productSalesAttribute', {
      params: {
        MaxResultCount: pageSize,
        SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize
      }
    })
  }
}
